<template>
  <div>
    <v-row class="actions-bar pa-4 bar-shadow primary-background">
      <EmployeesFilter />
    </v-row>

    <v-row class="pa-4">
      <v-col>
        <v-card>
          <EmployeesTable />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';

import EmployeesFilter from './EmployeesFilters.vue';
import EmployeesTable from './EmployeesTable.vue';

export default {
  components: {
    EmployeesFilter,
    EmployeesTable,
  },
  data() {
    return {
      isFiltersOpened: true,
    };
  },
  created() {
    this.getEmployees();
  },
  methods: {
    ...mapCacheActions('employees/list', ['getEmployees']),
  },
};
</script>
